import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://admin.1oneplus.net/api';

export const sendForgetPasswordEmail = createAsyncThunk(
  'forgetPassword/sendEmail',
  async ({ email, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/forget-password`,
        { email },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'lang': lang || 'en',
          },
        }
      );

      if (response.data.status === false) {
        return rejectWithValue(response.data.message || 'Failed to send reset code');
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message || 'Failed to send reset code');
      }
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const verifyResetCode = createAsyncThunk(
  'forgetPassword/verifyCode',
  async ({ email, code, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/verify-reset-code`,
        { email, code },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'lang': lang || 'en',
          },
        }
      );

      if (response.data.status === false) {
        return rejectWithValue(response.data.message || 'Invalid code');
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message || 'Invalid code');
      }
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const resendForgetCode = createAsyncThunk(
  'forgetPassword/resendCode',
  async ({ email, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/resend-forget-code`,
        { email },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'lang': lang || 'en',
          },
        }
      );

      if (response.data.status === false) {
        return rejectWithValue(response.data.message || 'Failed to resend code');
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message || 'Failed to resend code');
      }
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

export const resetPassword = createAsyncThunk(
  'forgetPassword/resetPassword',
  async ({ email, password, password_confirmation, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/reset-password`,
        { email, password, password_confirmation },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'lang': lang || 'en',
          },
        }
      );

      if (response.data.status === false) {
        return rejectWithValue(response.data.message || 'Failed to reset password');
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message || 'Failed to reset password');
      }
      return rejectWithValue(error.message || 'Network error');
    }
  }
);
